<script setup lang="ts">
import { ref } from 'vue'
import { useCollectibleChallengeLeaderboard } from '@/composables/game/leader-board'
import { useSpecialCollectibleChallenge } from '@/composables/game/challenges'
import CollectibleChallengeIcon from '@/assets/images/challenges/collectible/collectible-challenge-main-nye.webp'
import { usePathwayEventOverlay, usePathwayEvents } from '@/composables/game/pathway-events'
import CollectibleChallengeRulesModal from '@/components/modals/CollectibleChallengeRulesModal.vue'
import BaseChallengeOverlay from '@/components/overlays/BaseChallengeOverlay.vue'

defineProps<{
	show: boolean
}>()
const emit = defineEmits(['hide'])

const { pathwayEvents } = usePathwayEvents()
const { showFirstPathway } = usePathwayEventOverlay()
const {
  getCollectibleChallengeLeaderboard,
  collectibleChallengeLeaderboard: players,
  currentPlayer,
} = useCollectibleChallengeLeaderboard()
const {
  formattedCountdown,
  specialCollectibleChallenge,
  specialCollectibleChallengeCurrency,
  specialCollectibleChallengeName,
  currencyLabel,
  currencyImage,
} = useSpecialCollectibleChallenge()

const showRulesModal = ref(false)

function onCtaClick() {
  showFirstPathway(pathwayEvents.value)
  emit('hide')
}
</script>

<template>
  <BaseChallengeOverlay
    :show="show"
    :challenge="specialCollectibleChallenge"
    :formatted-countdown="formattedCountdown"
    :on-cta-click="onCtaClick"
    :get-leaderboard="getCollectibleChallengeLeaderboard"
    :players="players"
    :current-player="currentPlayer"
    background-color="[background:linear-gradient(180deg,#FCA904_0%,#BF4C00_24.02%,rgba(109,25,3,0.00)_100%)]"
    :main-image="CollectibleChallengeIcon"
    timer-background-class="bg-[linear-gradient(90deg,#FBA704_0%,#B04501_50%,#411900_100%)]"
    :title="specialCollectibleChallengeName"
    description="Collect as many of the selected item, climb the ranks, and unlock your prize!"
    cta-text="Hunt items"
    :is-rule-card-clickable="true"
    rule-card-line2="Collect"
    :rule-card-image="currencyImage"
    :score-image="currencyImage"
    :currency-image="currencyImage"
    :currency-label="currencyLabel"
    :challenge-currency="specialCollectibleChallengeCurrency"
    @hide="emit('hide')"
    @open-rule-modal="showRulesModal = true"
  />

  <CollectibleChallengeRulesModal
    :show="showRulesModal"
    @hide="showRulesModal = false"
  />
</template>
